<template>
    <div class="modal fade" :id="id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor" />
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor" />
                </svg>
              </span>
          </div>
        </div>

        <div class="modal-body">
          <div class="d-flex justify-content-center align-items-center">
            <div class="" id="qrCodeDiv" ref="qrCodeDiv"></div>
          </div>

          <div class="d-flex justify-content-between mt-10">
            <span @click.prevent="changeExtensionType('png')" :class="{'bg-primary text-white': qrcodeFormat === 'png'}" class="col-3 cursor-pointer px-2 py-3 d-flex justify-content-center align-items-center rounded-2 w-full border">PNG</span>
            <span @click.prevent="changeExtensionType('jpeg')" :class="{'bg-primary text-white': qrcodeFormat === 'jpeg'}" class="col-3 cursor-pointer px-2 py-3 bg-gray-50 border-gray-300 d-flex justify-content-center align-items-center rounded-2 w-full border">JPEG</span>
            <span @click.prevent="changeExtensionType('svg')" :class="{'bg-primary text-white': qrcodeFormat === 'svg'}" class="col-3 cursor-pointer px-2 py-3 bg-gray-50 border-gray-300 d-flex justify-content-center align-items-center rounded-2 w-full border">SVG</span>
          </div>

          <Input
            container-class="mt-5"
            :name="`dimension`"
            type="number"
            :label="$t('events.qrcode_size')"
            labelClass="form-label fs-6 text-black"
            :inputClass="'form-control form-control-lg form-control-solid'"
            size="lg"
            :isRequired="false" 
            v-model="dwdDimension"
            :placeholder="$t('events.qrcode_size')"
          />

          <Button btn-class="btn-md w-100 mt-5" id="qr-download" type="new" btn-text="button.download" @click.prevent="downloadCustomQRCode"></Button>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import {ref, watch, onMounted} from "vue";
import Button from "@/components/Button";
import Input from "@/components/Input.vue"
import QRCodeStyling from 'qr-code-styling'
import nbu from '../../../../../public/assets/media/nbu.png'

const props = defineProps({
    id: {type: String, default: "event_qrcode_modal"},
    toEncode: {type: String, required: true},
    name: {type: String, default: "qrcode" },
    title: {type: String, default: "Qrcode" }
})


const dwdDimension = ref(300)
const qrcodeFormat = ref('png')
const qrCodeDiv = ref(null);
const qrCode = ref(null);

const options = ref({
  width: 300,
  height: 300,
  type: 'svg',
  data: '',
  image: ('/assets/media/nbu.png'),
  margin: 2,
  qrOptions: {
    typeNumber: 0,
    mode: 'Byte',
    errorCorrectionLevel: 'Q'
  },
  imageOptions: {
    hideBackgroundDots: true,
    imageSize: .6,
    margin: 0,
    crossOrigin: 'anonymous',
  },
  dotsOptions: {
    color: '#000000',
    type: 'square'
  },
  backgroundOptions: {
    color: '#ffffff',
  },
  cornersSquareOptions: {
    color: '#000000',
    type: 'square'
  },
  cornersDotOptions: {
    color: '#000000',
    type: 'square'
  }
});

watch(() => props.toEncode, (value) => {
  if(props.toEncode && qrCodeDiv.value) {
    qrCodeDiv.value.innerHTML = "";
    options.value.data = props.toEncode
    qrCode.value = new QRCodeStyling(options.value);
    qrCode.value.append(qrCodeDiv.value);
  }
})

function changeExtensionType(type){
  qrcodeFormat.value = type
}

function downloadCustomQRCode() {
  let optionsDownload = Object.assign({}, options.value)
  optionsDownload.height = (dwdDimension.value || 300);
  optionsDownload.width = (dwdDimension.value || 300);
 
  (new QRCodeStyling(optionsDownload)).download({ extension: qrcodeFormat.value, 'name': props.name })
}

 
function closeModal(){
      $('#'+props.id).modal('toggle')
    }


onMounted(() => {
  if(props.toEncode) {
    options.value.data = props.toEncode
    qrCode.value = new QRCodeStyling(options.value);
    qrCode.value.append(qrCodeDiv.value);
  }
})

</script>